import React from "react";
import PropTypes from "prop-types";
import { ScrollableContainer, TableContainer } from "./style";
import { ImageUrl } from "../../../utils/constants";
import { NameInitials } from "../../Manager/styles";
import { getInitials } from "../../../utils/methods";


const CommonTableInfiniteScroll = ({res,setPageNumberPaginationReceived, pageNumberReceived,title, headers, data=[], showAll, handleShowMore,imageBaseUrl,isPadding,hideHeaders,/*headersSpacing*/ }) => {

  const onScrollReceived = (e) => {

    
    const isBottom =
      Math.round(e.target.scrollHeight - e.target.scrollTop) === Math.round(e.target.clientHeight-1)||Math.round(e.target.scrollHeight - e.target.scrollTop) === Math.round(e.target.clientHeight);
    if (
      isBottom &&
      data?.length < res?.total
    ) {
      setPageNumberPaginationReceived(pageNumberReceived + 1); // Increment page number correctly
    }
  };
    

  return(
    <TableContainer hideHeaders={hideHeaders} isPadding={isPadding}>
      <div className="heading">{title}</div>
      {!hideHeaders && headers.length > 0 && (
        <div className="type">
          {headers.map((header, index) => (
            <div className="name" key={index}>{header}</div>
          ))}
        </div>
      )}
      <ScrollableContainer 
        height={showAll ? "380px" : "380px"}
        showAllRows={showAll}
        onScroll={(e)=>onScrollReceived(e)}>
        
        {data.length > 0 ? (data.slice(0, showAll ? data.length : 5).map((item, index) => (
          <div className="item" key={index}>
            <div className="item-left">
              { imageBaseUrl ? 
                item?.image !== "profile-Image/default.png" ? ( <div className="profile"> <img src={`${ImageUrl}/${item.image}`} alt={item.name} /> </div> ):
                  <NameInitials id="name-initials">
                    {getInitials(item?.name)}
                  </NameInitials>  
                : null}
              <div className="name">{item?.name}</div>
            </div>
            <div className="value">{item?.total_posts}</div>
          </div>
        ))):(<div className="no-data">No Data Found</div>)}
      </ScrollableContainer>
      {data.length > 5 && !showAll && (
        <div className="showmore">
          <div className="button" onClick={handleShowMore}>
            Show More
          </div>
        </div>
      )}
    </TableContainer>
  );
}

CommonTableInfiniteScroll.propTypes = {
  title: PropTypes.string.isRequired,
  headers: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  showAll: PropTypes.bool,
  isPadding: PropTypes.bool,
  handleShowMore: PropTypes.func.isRequired,
  imageBaseUrl: PropTypes.bool.isRequired,
  hideHeaders: PropTypes.bool, 
  pageNumberReceived: PropTypes.number,
  setPageNumberPaginationReceived: PropTypes.func,
  res:PropTypes.object
};

export default CommonTableInfiniteScroll;   
